<template>
    <div class="page">
        <div class="row reports">
            <div class="table-responsive">
                <table class="maintable reports">
                    <thead>
                        <tr>
                            <td>{{$t('TIME')}}</td>
                            <td>{{$t('CLIENT')}}</td>
                            <td>{{$t('QUANTITY')}}</td>
                            <td>{{$t('FILESNUM')}}</td>
                            <td>{{$t('NAME')}}</td>
                            <td>{{$t('PLATFORMS')}}</td>
                            <td>{{$t('ISREPEAT')}}</td>
                            <td style="width: 5px;"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in report.root" :key="i">
                            <td>{{formatDate(row.updateDateTime)}}</td>
                            <td>{{row.companyName}}</td>
                            <td>{{row.num}}</td>
                            <td>{{row.filesNum}}</td>
                            <td>{{$t(row.name)}}</td>
                            <td>{{row.platforms}}</td>
                            <td>{{(row.isRepeat == '1') ? $t('YES') : $t('NO')}}</td>
                            <td></td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2">{{ $t('TOTAL')+':' }}</td>
                            <td>{{total.num}}</td>
                            <td>{{total.filesNum}}</td>
                            <td colspan="2"></td>
                            <td>{{total.repeat}}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import dentalsolutionsApi from '@/api/dentalsolutions'
import moment from 'moment';

export default
{
    name: 'PrintDsDaily',
    data: function()
    {
        return {
            dentalsolutiontypes:
            {},
            companies:
            {
                root: [],
                totalCount: 0
            },
            report: {
                root: []
            },
            params:
            {
                date: new Date(),
                ordererCompanyId: '',
                dentalSolutionTypeId: null,
            }
        };
    },
    created: function()
    {
        var me = this;

        me.params = me.$route.query;

        me.getReport();
    },
    methods:
    {
        getReport()
        {
            var me = this;
            const params = { ...me.params };

            params.date = moment(params.date).format('YYYY-MM-DD');

            dentalsolutionsApi.getReport(params, function(data)
            {
                if (data.error)
                {
                    me.$notify.error(data.notice);
                }
                else
                {
                    me.report = data;
                }
            });
        }
    },
    computed:
    {
        total()
        {
            const me = this;

            let num = 0;
            let filesNum = 0;
            let repeat = 0;

            for(const item of me.report.root)
            {
                num += parseInt(item.num);
                filesNum += parseInt(item.filesNum);
                repeat += (item.isRepeat === '1') ? parseInt(item.filesNum) : 0;
            }

            return {
                num: num,
                filesNum: filesNum,
                repeat: repeat,
            };
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/PrintDsDaily.vue